export default __webpack_public_path__ + "a44a819d3e02626131cf741aebd7394d.png";